import { render, staticRenderFns } from "./PixellotPlayer.vue?vue&type=template&id=4f934c14&lang=pug&"
import script from "./PixellotPlayer.vue?vue&type=script&lang=js&"
export * from "./PixellotPlayer.vue?vue&type=script&lang=js&"
import style0 from "./PixellotPlayer.vue?vue&type=style&index=0&id=4f934c14&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/cms/cms/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4f934c14')) {
      api.createRecord('4f934c14', component.options)
    } else {
      api.reload('4f934c14', component.options)
    }
    module.hot.accept("./PixellotPlayer.vue?vue&type=template&id=4f934c14&lang=pug&", function () {
      api.rerender('4f934c14', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/shared/PixellotPlayer.vue"
export default component.exports